import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Feed, FeedAllowedViewsValues } from '../../models/core.models';

import { AppState } from 'src/app/reducers';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Observable, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { WidgetService } from '../../services/widget.service';
import { selectFeed } from '../../reducers';
import { toggleFeedView } from '../../actions/feed.actions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoggerService } from '@services/logger.service';

interface View {
  name: FeedAllowedViewsValues;
  icon: IconProp;
  selected: boolean;
}

@Component({
  selector: 'app-feed-views',
  templateUrl: './feed-views.component.html',
  styleUrls: ['./feed-views.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FeedViewsComponent implements OnInit {
  feed$: Observable<Feed>;
  feedId: string;

  private destroyRef = inject(DestroyRef);
  private logger = inject(LoggerService);
  constructor(private store: Store<AppState>) {
    this.feed$ = this.store.select(selectFeed);
  }

  availableViews: View[] = [
    {
      name: 'list',
      icon: ['fas', 'list'],
      selected: true,
    },
    {
      name: 'details',
      icon: ['fas', 'info-circle'],
      selected: true,
    },
    {
      name: 'analytics',
      icon: ['fas', 'chart-line'],
      selected: true,
    },
  ];

  ngOnInit(): void {
    this.feed$
      .pipe(
        tap((feed) => {
          if (feed) {
            this.availableViews = this.availableViews.map((view) => ({
              ...view,
              selected: feed.views?.includes(view.name),
            }));
            this.feedId = feed.id;
          }
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  setView(view: string) {
    this.logger.debug('setView', view);
  }

  toggleSelect(view, selected) {
    this.logger.debug('toggleSelect', view, selected);
    this.store.dispatch(
      toggleFeedView({
        feedId: this.feedId,
        view: view,
        selected: selected,
      }),
    );

    setTimeout(() => {
      // trigger window:resize event
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }
}
